import fetcher from '../../fetcher';

const register = ({ email }) => fetcher(`/register`, 'POST', { email });

export default register;
